var BASE = '/api/grocery';
var headers = { 'Content-Type': 'application/json' };
var opts = { credentials: 'include', headers: headers };

async function handleResponse(res, fallbackMsg) {
  if (res.ok) return res.json();
  var body;
  try { body = await res.json(); } catch (e) { body = null; }
  var msg = body?.error || body?.message || fallbackMsg;
  if (res.status === 401) msg = 'Session expired — please log in again';
  throw new Error(msg);
}

export var fetchList = async () => {
  var res = await fetch(BASE, { credentials: 'include' });
  return handleResponse(res, 'Failed to fetch grocery list');
};

export var addItem = async (item) => {
  var res = await fetch(BASE + '/items', { ...opts, method: 'POST', body: JSON.stringify(item) });
  return handleResponse(res, 'Failed to add item');
};

export var addItemsBulk = async (items) => {
  var res = await fetch(BASE + '/items/bulk', { ...opts, method: 'POST', body: JSON.stringify({ items }) });
  return handleResponse(res, 'Failed to add items');
};

export var toggleItem = async (itemId) => {
  var res = await fetch(BASE + '/items/' + itemId + '/toggle', { ...opts, method: 'PUT' });
  return handleResponse(res, 'Failed to toggle item');
};

export var removeItem = async (itemId) => {
  var res = await fetch(BASE + '/items/' + itemId, { ...opts, method: 'DELETE' });
  return handleResponse(res, 'Failed to remove item');
};

export var clearChecked = async () => {
  var res = await fetch(BASE + '/clear-checked', { ...opts, method: 'POST' });
  return handleResponse(res, 'Failed to clear checked items');
};

export var clearAll = async () => {
  var res = await fetch(BASE + '/clear-all', { ...opts, method: 'POST' });
  return handleResponse(res, 'Failed to clear list');
};
